/* eslint-disable import/prefer-default-export */
import { Languages, Tree } from '@livv/models';
import { I18n } from 'next-translate';
import { getDate } from '@utils/date';

export const formatSubtitleElements = (
    bookMeta: Omit<Tree, 'content'>,
    isLegitext: boolean,
    { t, lang }: I18n,
): string[] => {
    const { authors, displayedUpdateDate } = bookMeta;
    if (isLegitext) {
        return [`${t('updatedAt')} ${getDate(displayedUpdateDate.toDate(), lang as Languages)}`];
    }

    return [`${t('author', { count: authors.length })} : ${authors.join(', ')}`];
};
